// extracted by mini-css-extract-plugin
export default {"webform":"one-trust-webform-legacy-module--webform--484cc"};